<template>
<div>
	<div class="honor-container"  v-if="form.custom.selectedDescription">
    <div v-if="form.custom.selectedDescription === 'Mother-Daughter Birthday/Bat mitzvah Club'">
      <FormRow>
        <div style="flex: 1;margin-right: 10px;">
          <FormLabel class="control-label">Name of Child</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.nameOfChild"
          />
        </div>
        <div style="margin-right: 10px;">
          <FormLabel class="control-label">Birthdate</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.birthdate"
          />
        </div>
        <div>
          <FormLabel class="control-label">Child Age</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.childAge"
          />
        </div>
      </FormRow>
      <FormRow inline>
        <div>
          <FormLabel class="control-label">Event Name</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.eventName"
          />
        </div>
        <div>
          <FormLabel class="control-label">Event Location</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.eventLocation"
          />
        </div>
      </FormRow>
      <FormRow inline>
        <FormCol field="dedicationMessage"  :flex="3"/>
      </FormRow>
    </div>
		<div v-if="form.custom.selectedDescription === 'Individual Shiur'">
      <FormRow inline>
        <FormCol field="dedication" :flex="1">
          <option value="In honor of">In honor of</option>
          <option value="In memory of">In memory of</option>
        </FormCol>
        <FormCol field="dedicationMessage"  :flex="3"/>
      </FormRow>
      <FormRow inline>
        <div>
          <FormLabel class="control-label">Date of Shiur</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.shiurDate"
          />
        </div>
        <div>
          <FormLabel class="control-label">Shiur or Teacher</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.shiurORTeacher"
          />
        </div>
      </FormRow>
		</div>
		<div v-if="form.custom.selectedDescription === 'Shiur year sponsorship'">
      <FormRow inline>
        <FormCol field="dedication" :flex="1">
          <option value="In honor of">In honor of</option>
          <option value="In memory of">In memory of</option>
        </FormCol>
        <FormCol field="dedicationMessage"  :flex="3"/>
      </FormRow>
      <FormRow inline>
        <div>
          <FormLabel class="control-label">Date of Shiur</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.shiurDate"
          />
        </div>
        <div>
          <FormLabel class="control-label">Shiur or Teacher</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.shiurORTeacher"
          />
        </div>
      </FormRow>
		</div>
		<div v-if="form.custom.selectedDescription === 'ATID or NextGen Event'">
      <FormRow inline>
        <FormCol field="dedication" :flex="1">
          <option value="In honor of">In honor of</option>
          <option value="In memory of">In memory of</option>
        </FormCol>
        <FormCol field="dedicationMessage"  :flex="3"/>
      </FormRow>
      <FormRow inline>
        <div>
          <FormLabel class="control-label">Date of Event</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.eventDate"
          />
        </div>
        <div>
          <FormLabel class="control-label">Which Event</FormLabel>
          <FormSelect field="custom.eventType" :flex="1">
            <option value="ATID">ATID</option>
            <option value="NextGen">NextGen</option>
          </FormSelect>
        </div>
      </FormRow>
		</div>
		<div  v-if="form.custom.selectedDescription === 'Mother-Daughter Event'">
      <FormRow inline>
        <FormCol field="dedication" :flex="1">
          <option value="In honor of">In honor of</option>
          <option value="In memory of">In memory of</option>
        </FormCol>
        <FormCol field="dedicationMessage"  :flex="3"/>
      </FormRow>
      <FormRow inline>
        <div>
          <FormLabel class="control-label">Date of Event</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.eventDate"
          />
        </div>
      </FormRow>
      <FormRow inline>
        <div>
          <FormLabel class="control-label">Event Name</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.eventName"
          />
        </div>
        <div>
          <FormLabel class="control-label">Event Location</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.eventLocation"
          />
        </div>
      </FormRow>
		</div>
		<div  v-if="form.custom.selectedDescription === `Women's Beit Midrash - morning of learning`">
      <FormRow inline>
        <FormCol field="dedication" :flex="1">
          <option value="In honor of">In honor of</option>
          <option value="In memory of">In memory of</option>
        </FormCol>
        <FormCol field="dedicationMessage"  :flex="3"/>
      </FormRow>
      <FormRow inline>
        <div>
          <FormLabel class="control-label">Date of Event</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.eventDate"
          />
        </div>
      </FormRow>
		</div>
		<div  v-if="form.custom.selectedDescription === `Rosh Chodesh or Nach Yomi seminar`">
      <FormRow inline>
        <FormCol field="dedication" :flex="1">
          <option value="In honor of">In honor of</option>
          <option value="In memory of">In memory of</option>
        </FormCol>
        <FormCol field="dedicationMessage"  :flex="3"/>
      </FormRow>
      <FormRow inline>
        <div>
          <FormLabel class="control-label">Name of Event</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.eventName"
          />
        </div>
      </FormRow>
		</div>
		<div v-if="form.custom.selectedDescription === '6-8 part series of Shiurim'">
      <FormRow inline>
        <FormCol field="dedication" :flex="1">
          <option value="In honor of">In honor of</option>
          <option value="In memory of">In memory of</option>
        </FormCol>
        <FormCol field="dedicationMessage"  :flex="3"/>
      </FormRow>
      <FormRow inline>
        <div>
          <FormLabel class="control-label">Name of Series</FormLabel>
          <FormInput
            type="text"
            class="width-full"
            field="custom.seriesName"
          />
        </div>
      </FormRow>
		</div>
		<div v-if="form.custom.selectedDescription === 'Subidize an ATID student for a year'">
      <FormRow inline>
        <FormCol field="dedication" :flex="1">
          <option value="In honor of">In honor of</option>
          <option value="In memory of">In memory of</option>
        </FormCol>
        <FormCol field="dedicationMessage"  :flex="3"/>
      </FormRow>
		</div>
		<FormRow v-if="form.custom.selectedDescription !== 'Mother-Daughter Birthday/Bat mitzvah Club'">
			<input type="checkbox" id="mentionTidbits" name="mentionTidbits" @click="setValue('custom.mentionTidbits', $event.target.checked)"/>
			<FormLabel for="mentionTidbits">I'm interested in having my dedication be mentioned in Torah Tidbits.</FormLabel>
		</FormRow>
	</div>
</div>
</template>
<script lang="ts">
import { usePaymentForm } from '~/shared/use-payment-form'
import { defineComponent, type PropType, ref, watch } from 'vue'

export default defineComponent({
  setup(props) {
	  const inHonorOf = false
	  const dateType = 'dedicationDateFlag'
	  const { form, setValue } = usePaymentForm()

	  setValue('callback', process.env.NODE_ENV != 'production' ? 'https://ouisrael.oudev.org/wp-json/api/torah-tidbits/email-dedication' : 'https://ouisrael.org/wp-json/api/torah-tidbits/email-dedication')

	  return {
		  form,
      setValue,
		  inHonorOf,
		  dateType
	  }
  }
})
</script>
<style scoped lang="scss">
input[type="checkbox"] {
	margin-right: 7px;
}
.honor-container {
	padding-top: 20px;
	border-top: 1px solid #ddd;
	margin-top: 20px;
}
.flex {
	display: flex;
	align-items: center;
}
.honor-type {
	max-width: 150px;
	min-width: 150px;
	margin-right: 7px;
}
.edit-recipient {
	color: $color-blue;
	font-size: 13px;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}
}
.radio-part {
	flex: 1;
}
.date-field {
	flex: 3
}
.control-label {
	flex: 1;
    max-width: 150px;
    padding-top: 3px;
    padding-bottom: 3px;
    display: block;
}
</style>
